import { DeleteFacesFeature } from '@kb3d/models/classes/features/delete-faces-feature';
import { Token } from '@kb3d/models/classes/token';
import { FeatureRenderer } from './feature';
import { DeleteFacesGeometryProcessor } from './geometry-processor/delete-faces-geometry';

export class DeleteFacesRenderer extends FeatureRenderer<DeleteFacesFeature> {
    modelToken = Token.DeleteFacesFeature;
    processor = new DeleteFacesGeometryProcessor(this.scene);

    update3dInternal() {}
}
